import { ACTIVE_NETWORK } from './appConfig';

// ============================================================
// FILL THESE ADDRESSES AFTER DEPLOYMENT
// ============================================================
export const CONTRACT_ADDRESSES = {
  mainnet: {
    storage: '0x1CbD741873412E309CF56AcA5Fbf4346037f22d2',
    logic:   '0xe5cA59e64F6C5179c3f7b9f06083e4B01F88577C',
    admin:   '0xbFDab435631Ba027F1451F3f3f1C9759d6bFB15d', // ZenovaAdmin
    views:   '0x46f7aB31EE9eB5AD2F016AfB19e13AE469c03593',
    usdc:    '0x349d9836dd52c25e61Ae745e3da0F8989De63745',
    zenova:  '0xA3D14AFDc0673eB40831954e9ee259b3Da650669'
  },
  testnet: {
    storage: '0x964fE200812567c86D5384E9AaF0ffC78D0708F8',
    logic:   '0x62483f3ffFDB8DE2b019777B383a44FAA8E32aD5',
    admin:   '0x4Dcf4302d8B84E429de0BD1665ee90D7b49344Ca', // ZenovaAdmin
    views:   '0x997b43fDaDe63E9C03F0BeC1E5B1dDa4CB366c85',
    usdc:    '0xF9EDAE78D4463ba94B533a5E81FA3CEBA822bf18',
    zenova:  '0x9015e335f28cbad84EB255d5205CDb51B08A1B70'
  }
};

export const ADDR = CONTRACT_ADDRESSES[ACTIVE_NETWORK];

// Check if contracts are configured
export const areContractsConfigured = () => {
  const zero = '0x0000000000000000000000000000000000000000';
  return (
    ADDR.storage !== zero &&
    ADDR.logic   !== zero &&
    ADDR.admin   !== zero &&
    ADDR.views   !== zero &&
    ADDR.usdc    !== zero
  );
};

// Token decimals
export const USDC_DECIMALS = 6;
export const ZENOVA_DECIMALS = 18;
